<template>
  <div class="enps-tooltip">
    <table class="table table-sm mb-0">
      <tr>
        <td>
          <b>{{ $t('groupsComparison.currentValue') }}:</b>
        </td>
        <td>{{ Math.round(npsData.score) }}</td>
        <td></td>
      </tr>
      <tr>
        <td>
          <b>{{ $t('groupsComparison.nps_promoters') }}:</b>
        </td>
        <span>
          {{ npsData.promoters }}
          -
          {{ Math.round(npsData.promotersPercentage * 100) }}%
        </span>
      </tr>
      <tr>
        <td>
          <b>{{ $t('groupsComparison.nps_passives') }}:</b>
        </td>
        <span>
          {{ npsData.passives }} -
          {{ Math.round(npsData.passivesPercentage * 100) }}%
        </span>
      </tr>
      <tr>
        <td>
          <b>{{ $t('groupsComparison.nps_detractors') }}:</b>
        </td>
        <span>
          {{ npsData.detractors }} -
          {{ Math.round(npsData.detractorsPercentage * 100) }}%
        </span>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'NpsTooltip',
  props: {
    npsData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.enps-tooltip {
  position: fixed;
  border: 1px solid var(--kt-card-border-color);
  box-shadow: var(--kt-card-box-shadow);
  transform: translateY(calc(-100% - 5px));
  z-index: 1000;
  display: none;
  white-space: nowrap;
  background-color: var(--kt-light) !important;
  border-radius: var(--bs-card-inner-border-radius);
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  background: var(--kt-gray-900);
}
</style>
